import { render, staticRenderFns } from "./SamplePopover.vue?vue&type=template&id=4046b7dc&"
import script from "./SamplePopover.vue?vue&type=script&lang=js&"
export * from "./SamplePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports